import { useCallback, useEffect, useState } from "react"
import { useConnection, useWallet } from "@solana/wallet-adapter-react"
import {
	createStakeTokenTransaction,
	createUnstakeTokenTransaction,
	getRewardCalculator,
	checkCandyMachineStakable,
} from "../../utils/staking"

import {
	PublicKey,
	SystemProgram,
	SYSVAR_RENT_PUBKEY,
	Transaction,
	TransactionInstruction,
} from "@solana/web3.js"
import { useNfts } from "../../hooks/useNfts"

export default function AkumaCardstaking({ nft, onChange, PROGRAMS }) {
	if (!nft) return null;
	
	///const [PROGRAMS, setPROGRAMS] = useState(() => PROGRAMS)
	const { connection } = useConnection()
	const { publicKey, sendTransaction } = useWallet()

	let [name, number] = nft.json.name.split("#")
	let isStaked = "timestamp" in nft
	const cooldownEndDate = nft.timestamp
	const [timestamp, setTimestamp] = useState(() => nft.timestamp)
	const [isSure, setIsSure] = useState(() => {
		return {
			open: false,
			pid: nft.pid,
			minPeriod: "",
		}
	})

	// console.log("formate" + formatTimeUntil(Date(nft.timestamp)))
	// console.log("endate formate" + formatTimeUntil(Date(nft.cooldownEndDate)))
	//console.log("endate " + nft.cooldownEndDate)
	// console.log("time " + nft.timestamp)

	const [cooldownEnded, setCooldownEnded] = useState<boolean>(true)
	const [pid, setPid] = useState(() => nft.pid)

	const checkCooldown = useCallback(
		(now: Date) => {
			if (!cooldownEndDate) return

			let cooldownEndedNow = cooldownEndDate <= now.getTime()
			if (cooldownEndedNow !== cooldownEnded) setCooldownEnded(cooldownEndedNow)
		},
		[cooldownEndDate, cooldownEnded]
	)
	useEffect(() => {
		setTimestamp(() => nft.timestamp)
	}, [nft])

	useEffect(() => {
		setPid(() => {
			return nft.pid
		})
	}, [isStaked, connection, onChange])

	const [stakingModal, setStakingModal] = useState(false)
	const [timer, setTimer] = useState(null)
	const [countdownStakeTime, setCountdownStakeTime] = useState(null)
	const [sinceStakeTime, setSinceStakeTime] = useState(null)
	const [transaction, setTransaction] = useState(null)

	const sendAndConfirmTransaction = useCallback(
		async (transaction) => {
			try {
				console.log({ transaction })
				let { blockhash } = await connection.getRecentBlockhash()
				transaction.feePayer = await publicKey
				transaction.recentBlockhash = await blockhash

				let signature = await sendTransaction(transaction, connection)
				await connection.confirmTransaction(signature, "confirmed")

				console.log(signature)

				if (onChange) onChange()

				return signature
			} catch (error) {
				console.log(error)
			}
		},
		[connection, publicKey, sendTransaction, onChange]
	)

	const stakeToken = useCallback(
		async (address, pid) => {
			console.log("transaction START", address)
			setStakingModal(false)
			await setTransaction(() => true)

			if (!publicKey) return
			await sendAndConfirmTransaction(
				await createStakeTokenTransaction(connection, publicKey, address, pid)
			)
			await setTransaction(() => true)

			console.log("transaction END", address)
		},
		[connection, publicKey, setStakingModal, sendAndConfirmTransaction]
	)
	const unstakeToken = useCallback(
		async (nft) => {
			await setTransaction(() => true)
			console.log("transaction START", nft)

			if (!publicKey) return
			await sendAndConfirmTransaction(
				await createUnstakeTokenTransaction(connection, publicKey, nft)
			)
			setTransaction(() => false)

			console.log("transaction END", nft)
		},
		[connection, publicKey, sendAndConfirmTransaction]
	)
	// alert(PROGRAMS[0].ID)
	// const staking = (pid) => {
	// 	if () {

	// }
	// }
	const timeoutmodal = () => {
		setStakingModal(() => false)
	}

	const formatTime = {
		Until: (date: Date): string => {
			const now = new Date()
			const diff = date.getTime() - now.getTime()
			// format days:hours:minutes:seconds
			const days = Math.floor(diff / (1000 * 60 * 60 * 24))
			const hours = Math.floor(diff / (1000 * 60 * 60)) % 24
			const minutes = Math.floor(diff / (1000 * 60)) % 60
			const seconds = Math.floor(diff / 1000) % 60

			if (days !== 0) {
				return `${days} ${days === 1 ? "day" : "days"}`
			}
			if (hours !== 0) {
				return `${hours} ${hours === 1 ? "hour" : "hours"}`
			}

			if (minutes !== 0) {
				return `${minutes} ${minutes === 1 ? "minute" : "minutes"}`
			}

			return `${seconds} ${seconds === 1 ? "second" : "seconds"}`
		},

		Since: (date: Date): string => {
			const now = new Date()
			//@ts-ignore
			const diff = -(
				//@ts-ignore

				(new Date(parseInt(date, 10) * 1000).getTime() - now.getTime())
			)
			// console.log("THIS IS THE TIME NOW ")
			// console.log("now", now)
			// console.log("date", new Date(parseInt(date, 10) * 1000))
			// console.log("THIS IS THE TIME NOW ")

			// 		"TIMESTAMP",
			// 		new Date(),
			// 		"DATENNOW"
			// format days:hours:minutes:seconds
			const days = Math.floor(diff / (1000 * 60 * 60 * 24))
			const hours = Math.floor(diff / (1000 * 60 * 60)) % 24
			const minutes = Math.floor(diff / (1000 * 60)) % 60
			const seconds = Math.floor(diff / 1000) % 60

			// const days = Math.floor(since / (1000 * 60 * 60 * 24))
			// const hours = Math.floor(since / (1000 * 60 * 60)) % 24
			// const minutes = Math.floor(since / (1000 * 60)) % 60
			// const seconds = Math.floor(since / 1000) % 60

			if (days !== 0) {
				return `${days}${days === 1 ? "day" : "days"} ${hours}${
					hours === 1 ? "hr" : "hrs"
				} ${minutes}${minutes === 1 ? "min" : "mins"}`
			}
			if (hours !== 0) {
				return `${hours}${hours === 1 ? "hr" : "hrs"} ${minutes}${
					minutes === 1 ? "min" : "mins"
				}`
			}

			if (minutes !== 0) {
				return `${minutes}${minutes === 1 ? "min" : "mins"} ${seconds}${
					seconds === 1 ? "sec" : "secs"
				}`
			}

			return `${seconds} ${seconds === 1 ? "sec" : "secs"}`
		},
	}
	useEffect(() => {
		let idcount = setInterval(
			() =>
				setCountdownStakeTime(() => formatTime.Until(new Date(nft.stakehold))),
			1000
		)
		let idcount2 = setInterval(
			() => setSinceStakeTime(() => formatTime.Since(nft.timestamp)),
			1000
		)

		if (new Date(nft.stakehold) < new Date()) {
			setSinceStakeTime(() => formatTime.Since(nft.timestamp))
		} else {
			setCountdownStakeTime(() => formatTime.Until(new Date(nft.stakehold)))
		}

		return () => {
			clearInterval(idcount)
			clearInterval(idcount2)
		}
	}, [formatTime])

	const youSure = (pid) => {
		setIsSure(() => {
			return {
				open: true,
				pid: nft.pid,
				minPeriod: "",
			}
		})
	}
	const canstake = () => {
		if (nft.stakable == PROGRAMS[0].ID.toString()) {
			console.log(nft.stakable, "YOOOO this equals program one")
			return true
		} else {
			console.log(nft.stakable, "YOOOO this equals program two")

			return false
		}
	}

	return (
		<div
			//	onMouseEnter={() => clearTimeout(timeoutmodal)}
			onMouseLeave={() => setTimeout(timeoutmodal, 3500)}
			className={"akuma-card-wrapper" + (isStaked ? " staked" : "")}
		>
			{stakingModal && !isStaked && (
				<div className="modal">
					<p>READY TO STAKE... </p>

					<div className="stakingoptions">
						{nft.stakable == PROGRAMS[0].whitelist ? (
							<button
								className="stakingoption"
								onClick={() =>
									setIsSure(() => {
										return {
											open: true,
											pid: PROGRAMS[0].ID,
											minPeriod: new Date(
												new Date(
													parseInt(PROGRAMS[0].REWARDS.minPeriod, 10) * 1000
												).getTime() + new Date().getTime()
											).toString(),
										}
									})
								}
							>
								10 $MEAT /DAY
							</button>
						) : (
							<button
								className="stakingoption"
								onClick={() =>
									setIsSure(() => {
										return {
											open: true,
											pid: PROGRAMS[1].ID,
											minPeriod: new Date(
												new Date(
													parseInt(PROGRAMS[1].REWARDS.minPeriod, 10) * 1000
												).getTime() + new Date().getTime()
											).toString(),
										}
									})
								}
							>
								100 $MEAT /DAY
							</button>
						)}
					</div>

					<div
						className="yousure"
						style={!isSure.open ? { display: "none" } : { display: "flex" }}
					>
						<div className="wrapper">
							<h1>You Sure?</h1>
							{true ? (
								<div></div>
							) : (
								<p>
									This NFT will be <br /> unavailable until: <br />
								</p>
							)}
							<p>{isSure.minPeriod}</p>
							<button
								onClick={async () => {
									await stakeToken(nft.mint, isSure.pid)
								}}
							>
								YUP!
							</button>
						</div>
					</div>
				</div>
			)}
			<img
				className="akuma-card-img"
				src={nft.json.image}
				alt={name + " icon"}
			></img>
			<div className="akuma-card-row">
				<p className="akuma-card-number">#{number}</p>
				<div className="akuma-card-status-wrapper">
					<p className="akuma-card-status-label">{timer}</p>

					<p className={"akuma-card-status" + (isStaked ? " staked" : "")}>
						{transaction && "loading..."}
						{isStaked && !transaction && "Staked"}
						{!isStaked && !transaction && "Unstaked"}
					</p>
				</div>
			</div>
			<p className="akuma-card-name">{name}</p>
			<p>
				{isStaked && new Date(nft.stakehold) > new Date()
					? "Unstake in " + countdownStakeTime
					: isStaked && !stakingModal && new Date(nft.stakehold) < new Date()
					? "Staked: " + sinceStakeTime
					: ""}
			</p>
			<button
				className={
					"akuma-card-button" +
					(new Date(nft.stakehold) > new Date() ? " stakeperiod" : "")
				}
				disabled={new Date(nft.stakehold) > new Date()}
				onClick={
					isStaked
						? () => unstakeToken(nft)
						: () => {
								setStakingModal((stakingModal) => !stakingModal)
								setIsSure(() => {
									return {
										open: false,
										pid: "",
										minPeriod: "",
									}
								})
						  }
				}
			>
				{!isStaked && stakingModal
					? "Cancel"
					: isStaked && timestamp
					? "Unstake"
					: "Stake"}
			</button>
		</div>
	)
}
